var _g, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFocus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 349.464 349.464",
    viewBox: "0 0 349.464 349.464",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#03b6fc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m36.54 194.948c-10.848-32.102-8.437-66.554 6.79-97.003 15.251-30.497 41.517-53.332 73.971-64.293l-9.559-28.265c-39.953 13.503-72.312 41.63-91.101 79.216-18.808 37.621-21.785 80.207-8.36 119.904z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m332.825 84.603c-18.79-37.579-51.148-65.713-91.108-79.216l-9.559 28.265c32.454 10.967 58.726 33.802 73.971 64.293 15.227 30.455 17.638 64.902 6.79 97.003l28.259 9.559c13.432-39.698 10.455-82.283-8.353-119.904z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m293.921 293.527-21.839-20.323c-48.135 51.727-128.992 55.026-180.247 7.333l-20.323 21.839c29.995 27.913 68.177 41.702 106.377 41.702 42.395 0 84.807-17 116.032-50.551z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 174.733,
    cy: 166.319,
    fill: "#394e6f",
    r: 14.613
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFocus);
export default __webpack_public_path__ + "static/media/focus.15f36613109129dde3fc7d762fbb3600.svg";
export { ForwardRef as ReactComponent };